module.exports = __webpack_public_path__ + "Carota-863.jpg";